/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Data: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M7.81348 4.07324C8.3254 3.86604 8.90801 4.11308 9.11523 4.625C9.3224 5.13691 9.07538 5.71954 8.56348 5.92676C5.88583 7.01074 4.00001 9.63558 4 12.6982C4 16.7309 7.26913 20 11.3018 20C14.3644 20 16.9893 18.1142 18.0732 15.4365C18.2805 14.9246 18.8631 14.6776 19.375 14.8848C19.8869 15.092 20.134 15.6746 19.9268 16.1865C18.5476 19.5936 15.207 22 11.3018 22C6.16456 22 2 17.8354 2 12.6982C2.00001 8.79301 4.40644 5.45237 7.81348 4.07324ZM12 2C17.5228 2 22 6.47715 22 12C22 12.5523 21.5523 13 21 13H12C11.4477 13 11 12.5523 11 12V3L11.0049 2.89746C11.0562 2.39333 11.4823 2 12 2ZM13 11H19.9355C19.4842 7.38149 16.6185 4.51479 13 4.06348V11Z'
      fill='currentColor'
    />
  </React.Fragment>
)
